module.exports = __webpack_public_path__ + "static/ratflap_img_diagram_alt_1-85f3b7748e3105637127ee8f0fd79aeb.jpg";